import { cn, MergeProps } from '@devsisters/wds-react';
import React from 'react';

const REGEXP_EXTERNAL_LINK = /^(https?:)?\/\//;

// XXX(inseopkim): gatsby의 링크 컴포넌트와 타입이 다른 문제
type AnchorProps = Omit<React.ComponentPropsWithoutRef<'a'>, 'key' | 'contentEditable'>;
type BaseProps = {
  href: string;
};

type Props = MergeProps<AnchorProps, BaseProps>;
function ExternalLink(props: Props) {
  const { className, href, target, rel, children, ...anchorProps } = props;

  if (!REGEXP_EXTERNAL_LINK.test(href)) {
    throw new Error(`ExternalLink: 외부 링크를 사용해야합니다. ${href}`);
  }

  return (
    <a
      className={cn('flex items-center gap-2', className)}
      href={href}
      target={target || '_blank'}
      rel={rel || 'noreferrer noopener'}
      {...anchorProps}
    >
      {children}
    </a>
  );
}

export default ExternalLink;
